import React, { useEffect, useState } from 'react'
import { Col, Container, Row, Stack } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../components/Button/Button'
import './MeetingFinished.scss'

export const CleanupDatabase = () => {
  const [success, setSuccess] = useState({
    meetingDb: false,
    loggerDb: false,
  })

  const [allSuccess, setAllSuccess] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    const req1 = indexedDB.deleteDatabase('InPersonMeetingDb')
    const req2 = indexedDB.deleteDatabase('LoggerDB')

    req1.onerror = () => {
      console.error('Error deleting database.')
    }

    req1.onsuccess = () => {
      console.log('Database deleted successfully')
      setSuccess((prev) => ({
        ...prev,
        meetingDb: true,
      }))
    }

    req2.onerror = () => {
      console.error('Error deleting database.')
    }

    req2.onsuccess = () => {
      console.log('Database deleted successfully')
      setSuccess((prev) => ({
        ...prev,
        loggerDb: true,
      }))
    }
  }, [])

  useEffect(() => {
    setAllSuccess(Object.values(success).every(Boolean))
  }, [success, navigate])

  const goToStartPage = () => {
    navigate(`/workspace/live-meetings`)
  }

  return (
    <Container>
      <Row>
        <Col className='d-flex align-items-center justify-content-center' xs={12}>
          {!allSuccess && (
            <div className='skeleton pt-2' style={{ width: '100%', height: '60px' }}>
              <div className='d-flex flex-column align-items-center'>
                <div>Cleaning up databases...</div>
                <div className='small-medium'>It may take a few seconds</div>
              </div>
            </div>
          )}
          <Stack direction='horizontal' gap={3}>
            {allSuccess && (
              <Button variant='darkGhost' onClick={goToStartPage}>
                <i className='bi bi-arrow-bar-left' /> Go to main page
              </Button>
            )}
          </Stack>
        </Col>
      </Row>
    </Container>
  )
}
